import React, {Component} from 'react';
import {BrowserRouter, Switch, Route } from 'react-router-dom'
import logo from './logo.svg';
import './App.css';
import Navbar from './Components/layout/Navbar'
import SignIn from './Components/auth/SignIn'
import Cluster from './Components/links/Cluster'
import Reports from './Components/links/Reports'
import ReportsReal from './Components/links/Reports Real'
import ReportsFake from './Components/links/Reports Fake'
const ShowRealLocation = props => {
  return <button className="button" onClick={props.showReal}>Show real locations</button>
}
const ShowFakeLocation = props => {
  return <button className="button" onClick={props.showFake}>Show fake locations</button>
}
const ShowALlLocation = props => {
  return <button className="button" onClick={props.showAll}>Show All locations</button>
}
class App extends Component{
  constructor(props) {
    super(props);
    this.state = {
      uploads: [],
      choose:0
    };
  this.report = <ReportsFake/>;
  this.onReport = this.onReport.bind(this);
  }

  triggerShowRealState = () => {
    this.setState({
      ...this.state,
      choose: 1,
    })
    this.onReport();
  }

  triggerShowFakeState = () => {
    this.setState({
      ...this.state,
      choose: 2,
    })
    this.onReport();
  }

  triggerShowAllState = () => {
    this.setState({
      ...this.state,
      choose: 0,
    })
    this.onReport();
  }
  onReport(){
    console.log("Print some text");
  switch (this.state.choose) {
    case 1:
        this.report = <ReportsReal/>
        break;
    case 2:
        this.report = <ReportsFake/>
        break;
    case 0:
        this.report = <Reports/>
        break;
  }
}
  render() {
    this.onReport()
    return (
      <BrowserRouter>
        <div className ="App">
          <Navbar />
          <div>
            
          </div>
            <Switch>
              <Route exact path='/' component={Cluster} />
              <Route path = '/signin' component ={SignIn}></Route>
              <Route path = '/reports'>
                <div style={{textAlign:"center"}}>
                  <ShowRealLocation showReal={this.triggerShowRealState} />
                  <ShowFakeLocation showFake={this.triggerShowFakeState} />
                  <ShowALlLocation showAll={this.triggerShowAllState} />
                  <div style={{textAlign:"left",marginLeft:"150px",marginRight:"150px"}}>
                    {this.report}
                  </div>
                </div>
              </Route>
            </Switch>
        </div>
      
      </BrowserRouter>  
    )
  }
}
export default App;
